import React from 'react';
import { TagWrapper, CloseButton } from './styles';

interface SelectedTagProps {
	label: React.ReactNode;
	closable?: boolean;
	onClose?: (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
}

export function SelectedTag({ label, closable = false, onClose }: Readonly<SelectedTagProps>): JSX.Element {
	return (
		<TagWrapper>
			{label}
			{closable && onClose && <CloseButton onClick={onClose}>×</CloseButton>}
		</TagWrapper>
	);
}
